import { Injectable } from '@angular/core';
import {
	Router, Resolve,
	RouterStateSnapshot,
	ActivatedRouteSnapshot
} from '@angular/router';
import { NEVER, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BinderWizardService } from '../services/sections/binder/binder-wizard.service';
import { GlobalSettingsService } from '../services/ui/global-settings.service';

@Injectable({
	providedIn: 'root'
})
export class BinderTargetEmailResolver implements Resolve<Observable<{targetEmail: string}>> {
	constructor(
		private router: Router,
		private binderWizardService: BinderWizardService
	) { }
	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		return this.binderWizardService
			.getBinderTargerEmailAddress(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
